import { initialize } from 'redux-form'
import moment from 'moment'
import { findTimesheet } from '../../../HttpRequests/timesheets'
import { getJobs } from '../../../HttpRequests/jobs'
import { getProps } from '../props'
import { FORM_NAME } from '../Form'
import { setProjectSubcontractors, clearProjectSubcontractors } from '../State/projectSubcontractors'

const formatManualDeductionValue = (value) => {
  if (value === null) {
    return 'auto'
  }
  if (value === 0) {
    return 'none'
  }
  if (value === 0.5) {
    return '30m'
  }
  if (value === 1) {
    return '1h'
  }
  return null
}

export default () => async (dispatch) => {

  const { id, projectId } = getProps()

  const params = {
    include: 'timesheetPostings.project.clientSite.client',
  }

  // Clear any previous project subcontractors
  dispatch(clearProjectSubcontractors())

  // If projectId is provided, fetch subcontractors who are booked on this project (from planner jobs)
  if (projectId) {
    try {
      var jobParams = {
        'filter[project_id]': projectId,
      }
      var jobsResponse = await getJobs({ params: jobParams })
      
      // Handle different response structures - could be array directly or wrapped
      var responseData = jobsResponse.data
      var jobs = []
      if (Array.isArray(responseData)) {
        jobs = responseData
      } else if (responseData && responseData.data) {
        jobs = responseData.data
      } else if (responseData && responseData.rows) {
        jobs = responseData.rows
      }
      
      // Extract unique subcontractors from jobs (subcontractor is auto-loaded on Job model)
      var subcontractorMap = {}
      jobs.forEach(function(job) {
        if (job.subcontractor && !subcontractorMap[job.subcontractor.id]) {
          subcontractorMap[job.subcontractor.id] = job.subcontractor
        }
      })
      
      var projectSubcontractors = Object.values(subcontractorMap)
      dispatch(setProjectSubcontractors(projectSubcontractors))
    } catch (error) {
      console.error('Failed to fetch project subcontractors:', error)
    }
  }

  if (id) {

    const response = await findTimesheet({ id, params })

    const timesheet = response.data

    dispatch(initialize(FORM_NAME, {
      ...timesheet,
      manual_deduction: formatManualDeductionValue(timesheet.manual_deduction),
      day_rate: !timesheet.hourly_rate,
    }))

  } else {

    dispatch(initialize(FORM_NAME, {
      date: moment().format('YYYY-MM-DD'),
    }))

  }

}
